export default {
  accountInfo: '账户信息',
  personalInfo: '个人信息',
  bankInfo: '银行信息',
  trading_account_info: '交易账户信息',
  addCard: '添加香港银行卡',
  bankName: '银行名称',
  bankNum: '银行账号',
  englishName: '账户持有人姓名/英文',
  chineseName: '账户持有人姓名/中文',
  currency: '银行货币',
  uploadTitle: '上传银行证明(必须包含银行名称、银行账号及阁下姓名全名)',
  uploadTips: '证明文件可以是：</br>' +
  '1. 印有阁下姓名和银行账号的提款卡正面；</br>' +
  '2. 印有发出日期（3个月内）的银行开户信件；</br>' +
  '3. 印有发出日期（3个月内）的银行月结单副本/电子月结单。</br>',
  uploadNotice: '为了保障您的账户安全，如您递交的证明文件不符合要求，客服会第一时间与您联系。',
  records: '最新记录',
  toRecords: '添加记录',
  error: {
    bankNamePlaceholder: '请选择银行名称',
    bankAccountPlaceholder: '请输入正确的银行账号',
    englishNamePlaceholder: '请输入账户持有人姓名/英文',
    chineseNamePlaceholder: '请输入账户持有人姓名/中文',
    currencyPlaceholder: '请选择银行货币',
    otherCurrencyPlaceholder: '请上传银行证明',
    failed: '添加失败,请重试',
    '30014': '用户信息有误,请退出重新提交',
    '30015': '银行卡信息缺失,请重新提交',
    '30016': '银行卡号已被使用',
    '30017': '存在未处理订单'
  },
  currencyOpt: {
    'USD': '美元',
    'HKD': '港币',
    'CNY': '人民币'
  },
  noRecords: '无银行卡添加记录',
  name: '姓名',
  phone: '电话',
  email: '电子邮件',
  address: '地址',
  STOCK: '证券', // 补充
  FUTURES: '期货', // 补充
  FOREX: '外汇', // 补充
  IB: 'EddidPro',
  MF: 'FX Pro',
  PM: '现货黄金',
  account: '账户', // 补充
  balance: '余额', // 补充
  netCashBalance: '净现金结余', // 补充
  preBalance: '上日结存',
  loadingData: '正在加载数据...',
  balanceErr: '--',
  todayBalance: '当日结存',
  stockOptionsCash: '香港股票期权账户(现金)',
  securitiesCash: '香港及环球证券账户(现金)',
  securitiesMargin: '香港及环球证券账户(保证金)',
  securitiesDayTradeMargin: '香港证券即日买卖账户(保证金)',
  futuresMargin: '香港及环球期货账户(保证金)',
  futuresDayTradeMargin: '香港期货即日买卖账户(保证金)',
  interactiveBrokerIntegratedMargin: '盈透证券综合户口(保证金)',
  OPEN: '启用',
  STOP: '停用',
  CLOSE: '关闭',
  withdrawalLimit:
  '为符合监管机构要求，客户如欲使用其他新绑定之银行账户作任何出入金之用，该新绑定的银行账户需要有数额不少于10,000港元或等值货币的入金记录，否则艾德证券期货届时有机会未能处理阁下的出入金申请。',
  forbidWithdrawal:
  '此已绑定之银行账户未曾将数额不少于HKD10,000或等值的货币成功入金至艾德证券期货,因此未能透过此银行账户出金。',
  accountDormant: '阁下的交易账户{accountNumber}（「账户」）过去3年未有进行任何活动（包括交易、存款、提款、转入股票、转出股票 、更新账户资料、登入手机应用程式等），为保障客户利益，目前账户已被视为「不活跃户」，账户的提款及转出股票功能将受到限制。'
}
